import React from "react"
import classnames from "@utils/classnames"
import styles from "./colTitle.module.scss"

const ColTitle = React.memo(({ children, sub, ...restProps }) => {
  return (
    <h3
      {...restProps}
      className={classnames(styles.title, restProps.className)}
    >
      <span>{children}</span>
      <small>{sub}</small>
    </h3>
  )
})

ColTitle.displayName = "ColTitle"
export default ColTitle
